module.exports = __webpack_public_path__ + "static/media/Portrait-10249.2f0cb4aa.jpg";